// Registers the service worker (src/service-worker.js) in production builds
// and reports when a newer version of the portal is waiting.

export function register({ onUpdate } = {}) {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((registration) => {
        const notify = () => { if (registration.waiting && navigator.serviceWorker.controller) onUpdate?.(registration); };
        notify();
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed') notify();
          });
        });
        // Long-lived tabs (a phone left on the form all day) still learn about
        // new versions.
        setInterval(() => registration.update().catch(() => {}), 60 * 60 * 1000);
      })
      .catch((err) => console.error('Service worker registration failed', err));
  });
}

// Switch to the waiting version and reload once it has taken over.
export function applyUpdate(registration) {
  if (!registration?.waiting) return;
  let reloaded = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!reloaded) {
      reloaded = true;
      window.location.reload();
    }
  });
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
}
